<template>
  <TheTopbarModalLayout
    @click="goToMenu('TheTopbarNavbarMenuMain')"
    :name="$t('topbar.menu.labels.account')"
  >
    <template #content>
      <!-- pack info -->
      <div class="diy-topbar__menu-account-info">
        <!-- icon -->
        <div class="diy-topbar__menu-account-icon">
          <AppIcon v-if="!hasSubscription && !isEmployee" icon="far fa-tachometer-slow" />
          <img v-else :src="membershipPicture" alt="account-image" />
        </div>
        <!-- details -->
        <div class="diy-topbar__menu-account-details">
          <span class="diy-topbar__menu-account-name">
            <!-- no suscription -->
            <template v-if="!isEmployee && !hasSubscription">
              {{ $t(`suscriptions.names['no suscription']`) }}
            </template>
            <!-- has suscription -->
            <template v-else-if="!isEmployee && hasSubscription">
              {{ $t(`suscriptions.names.${membershipName}`) }}
            </template>
            <template v-else>
              {{ membershipName }}
            </template>
          </span>
          <span v-if="!isEmployee && hasSubscription" class="diy-topbar__menu-account-status">
            {{ $t('suscriptions.end_date', { date: formatedDate }) }}
          </span>
        </div>
      </div>
      <!-- IS CLIENT ⤵ -->
      <!-- my team -->
      <TheTopbarNavbarMenuItem
        v-if="!isEmployee"
        @click="goToMenu('TheTopbarNavbarMenuAccount')"
        icon="far fa-users-cog"
      >
        {{ $t('topbar.menu.labels.my_team') }}
      </TheTopbarNavbarMenuItem>
      <!-- end client -->

      <!-- email notifications -->
      <TheTopbarNavbarMenuItem icon="far fa-bell-exclamation">
        {{ $t('topbar.menu.labels.email_notifications') }}
        <template #append-content>
          <AppSwitch v-model="emailNotifications" @input="toggleNotifications" />
        </template>
      </TheTopbarNavbarMenuItem>
    </template>
  </TheTopbarModalLayout>
</template>

<script>
// Utilities
import { formatDate } from 'Utils'
import NavbarMenuMixin from '../mixins/navbar-menu'
// Components
import AppSwitch from 'Ui/AppSwitch'
import DIYAvatar from 'Images/logo/diy-avatar.png'
import TheTopbarModalLayout from './TheTopbarModalLayout'

export default {
  name: 'TheTopbarNavbarMenuAccount',

  components: {
    AppSwitch,
    AppIcon: () => import('Ui/AppIcon'),
    TheTopbarModalLayout,
  },

  mixins: [NavbarMenuMixin],

  data() {
    return {
      emailNotifications: true,
    }
  },

  computed: {
    formatedDate() {
      return formatDate(this.currentAccount.pack_end_date)
    },

    membershipName() {
      return this.isEmployee ? 'DIY Team' : this.currentAccount.pack_name
    },

    hasSubscription() {
      return this.currentAccount?.pack_name !== 'no suscription'
    },

    membershipPicture() {
      return this.isEmployee ? DIYAvatar : this.currentAccount.pack_icon.default
    },
  },

  methods: {
    async toggleNotifications() {
      await this.$store.dispatch('user/updateUserInfo', {
        email_notifications: this.emailNotifications,
      })
    },
  },

  mounted() {
    this.emailNotifications = this.currentUser.email_notifications
  },
}
</script>

<style scoped>
.diy-topbar__menu {
  width: 280px;
}

.diy-topbar__menu-account-info,
.diy-topbar__menu-account-details {
  display: flex;
}

.diy-topbar__menu-account-info {
  align-items: center;
  gap: 12px;
  padding: 5px 10px;
  user-select: none;
}

.diy-topbar__menu-account-details {
  flex-direction: column;
}

.diy-topbar__menu-account-details .diy-topbar__menu-account-name {
  font-size: 1rem;
  font-weight: 700;
  text-transform: capitalize;
}

.diy-topbar__menu-account-details .diy-topbar__menu-account-name::first-letter {
  text-transform: capitalize;
}

.diy-topbar__menu-account-details .diy-topbar__menu-account-status {
  font-size: 0.75rem;
  line-height: 1.25rem;
  letter-spacing: 0.01875rem;
  color: var(--c-magenta-500);
}

.diy-topbar__menu-account-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 0px 10px -3px rgb(2 5 68 /40%);
}

.diy-topbar__menu-account-icon img {
  width: 22px;
}

.fa-tachometer-slow {
  font-size: 18px;
  color: var(--c-magenta-500);
}
</style>

<style scoped src="@/assets/css/shared-styles/topbar-navbar.css"></style>
